<div class="task_card" *ngIf="taskData != null">
  <mat-card class="not-container">
    <div class="display-flex">
      <div class="main-div">
        <label class="exit_checklist_lbl">
          {{ taskData.subject }}
        </label>
        <label class="txt">
          {{ transformDescription(taskData.description) | underScoreToSpace }}
        </label>
      </div>
      <div class="col-lg-1 col-sm-6">
        <div class="exit-main-btn" *ngFor="let action of actions?.actions">
          <button *ngIf="!iscompletedtask" class="btn-exit-checklist" [disabled]="loadingButtonKey !== null"
            (click)="action.action(taskData.taskTransactionId, action.text)">
            {{
            loadingButtonKey === action.text
            ? convertToIng(action.text)
            : action.text
            }}
          </button>

          <button *ngIf="!iscompletedtask" class="btn-exit-checklist" [disabled]="loadingButtonKey !== null"
            (click)="action.action1(taskData.taskTransactionId, action.text1)">
            {{
            loadingButtonKey === action.text1
            ? convertToIng(action.text1)
            : action.text1
            }}
          </button>
        </div>
      </div>
    </div>
  </mat-card>
</div>
<div *ngIf="taskData == null"></div>

<div class="col-lg-14 col-md-14 col-sm-14"></div>